import { GtmTrackingType } from '../constants';
import TrackingHelperInstance from './gtmTrackingHelper';

class GtmProductImpressionClickDelegator {
	constructor() {
		this.type = GtmTrackingType.PRODUCT_CLICK;
		this.preventDefault = true;
		this.dataAttribute = 'data-gtm-tracking-type';

		this.dataMapper = [
			{
				defaultValue: TrackingHelperInstance.generateActionFieldString(),
				gtmKey: 'list',
			},
			{ dataName: 'data-product-title', gtmKey: 'name' },
			{ dataName: 'data-legacy-sku', gtmKey: 'id' },
			{ dataName: 'data-price-excl', gtmKey: 'price' },
			{ dataName: 'data-sku-category-name', gtmKey: 'category' },
			{ dataName: 'data-sku-item-category', gtmKey: 'item_category' },
			{ dataName: 'data-sku-item-category2', gtmKey: 'item_category2' },
			{ dataName: 'data-sku-item-category3', gtmKey: 'item_category3' },
			{ dataName: 'data-stock-status-ga', gtmKey: 'dimension27' },
			{ defaultValue: 1, gtmKey: 'position' },
		];
	}

	getTrackingData(target) {
		if (target === null || target.getAttribute('href') === undefined) {
			return null;
		}

		this.targetUrl = target.getAttribute('href');

		const currentTarget =
			target.getAttribute(this.dataAttribute) === this.type
				? target
				: TrackingHelperInstance.findClosestClickableElement(
						target,
						this.dataAttribute,
						this.type,
					);
		const trackingData =
			currentTarget !== null
				? TrackingHelperInstance.getRequiredDataAsObject(
						currentTarget,
						this.dataMapper,
					)
				: null;
		return trackingData
			? this.generateDataLayerTrackingObject(trackingData)
			: trackingData;
	}

	generateDataLayerTrackingObject(trackingData) {
		return {
			event: 'productImpressionClick',
			ecommerce: {
				click: {
					actionField: {
						list: trackingData.list,
					},
					products: [trackingData],
				},
			},
			eventCallback: this.callback.bind(this),
		};
	}

	callback() {
		window.location.assign(this.targetUrl);
	}
}

const GtmProductImpressionClickDelegatorInstance =
	new GtmProductImpressionClickDelegator();
export default GtmProductImpressionClickDelegatorInstance;

// for test purpose only
export const GtmProductImpressionClickDelegatorClass =
	GtmProductImpressionClickDelegator;
